import { Chip, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import { DrawerNavBar, Typography } from "@platform/design-system";

const DrawerHeader = ({
  clientName,
  hasChanges,
}: {
  clientName: string;
  hasChanges: boolean;
}): React.JSX.Element => {
  const title = `Final Decisions for ${clientName}`;
  return (
    <DrawerNavBar>
      <Box display="flex" justifyContent="space-between" flexGrow={1}>
        <Typography variant="display-small">{title}</Typography>
        <Tooltip
          title={
            hasChanges
              ? "Changes have been made since final decisions have been submitted."
              : "No changes have been made since final decisions have been submitted."
          }
          arrow
        >
          <Chip
            data-testid="drawer-header-chip"
            variant="outlined"
            label={hasChanges ? "Draft" : "Submitted"}
            color={hasChanges ? "default" : "secondary"}
            sx={
              hasChanges
                ? {
                    backgroundColor: "grey.200",
                    borderColor: "grey.200",
                  }
                : undefined
            }
          />
        </Tooltip>
      </Box>
    </DrawerNavBar>
  );
};

export { DrawerHeader };
